import { render, staticRenderFns } from "./transferListModal.vue?vue&type=template&id=6973d200&scoped=true&"
import script from "./transferListModal.vue?vue&type=script&lang=js&"
export * from "./transferListModal.vue?vue&type=script&lang=js&"
import style0 from "./transferListModal.vue?vue&type=style&index=0&id=6973d200&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6973d200",
  null
  
)

export default component.exports